<template>
  <form class="form form--contact" method="post" @submit.prevent="submitForm($event)" id="formContact" autocomplete="off">

    <Modal v-model="showModal" :title="formTitle" :status="formSuccess" :message="formMessage" @close="resetModal" template="contact" />

    <div class="row">
      <div class="col-sm-6">
          <div class="form-group">
              <label class="form-label" for="fristname">{{ translate("fristname") }}*</label>
              <input class="form-control" type="text" name="fristname" id="fristname" maxlength="100" value="" required>
          </div>
      </div>
      <div class="col-sm-6">
          <div class="form-group">
              <label class="form-label" for="surname">{{ translate("surname") }}*</label>
              <input class="form-control" type="text" name="surname" id="surname" maxlength="100" value="" required>
          </div>
      </div>
      <div class="col-sm-6">
          <div class="form-group">
              <label class="form-label" for="telephone">{{ translate("telephone") }}*</label>
              <input type="tel" class="form-control" id="telephone" name="telephone" maxlength="20" value="" required>
          </div>
      </div>
      <!-- <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label">{{ translate("department") }}*</label>
          <div class="form__group">
            <select class="form-select" id="department" name="department" disabled required>
              <option value="">{{ translate("please.select") }}</option>
              <option :value="translate('department.one')">{{ translate("department.one") }}</option>
              <option :value="translate('department.two')">{{ translate("department.two") }}</option>
              <option :value="translate('department.three')">{{ translate("department.three") }}</option>
            </select>
            <div class="form__icon"><i class="far fa-chevron-down"></i></div>
          </div>
        </div>
      </div> -->

      <div class="col-6">
        <div class="form-group">
          <label class="form-label" for="email">{{ translate("email") }}*</label>
          <input class="form-control" type="email" id="email" name="email" maxlength="50" value="" required>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="messages" class="form-label">{{ translate("messages") }}*</label>
          <textarea class="form-control" cols="40" rows="5" name="messages" id="messages" maxlength="10000" required></textarea>
        </div>
      </div>

      
      <div class="col-12">
        <div class="form__block mt-2">
            <div class="custom-control custom-checkbox">
                <input 
                type="checkbox" 
                class="custom-control-input" 
                name="privacyStatement"
                v-model="isChecked"
                @change="handleCheckboxChange"
                >
                <label class="custom-control-label" v-html="translate('privacy.statement.text')"></label>
            </div>
  
            <div class="form__btn">
                <button 
                    type="submit" 
                    class="btn btn--secondary" 
                    :disabled="!isChecked"
                    >
                    <span class="btn__title">{{ translate("submit") }}</span>
                </button>
            </div>
        </div>
      </div>

      
    </div>
  </form>
</template>

<script setup>

const isChecked = ref(false)

const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

import { useFormContact } from "@/composables/useFormContact";

import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  privacyStatement,
  submitForm,
  resetModal,
  translate,
} = useFormContact();


</script>

<style lang="scss" scoped></style>
